import ASfCallingCustomerInfo from './index.vue';

ASfCallingCustomerInfo.install = app => {
  app.component(ASfCallingCustomerInfo.name, ASfCallingCustomerInfo);
};

export default ASfCallingCustomerInfo;
